import React from 'react';
import { Listbox } from '@headlessui/react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseRounded from '@mui/icons-material/CloseRounded';

const Select = ({ name, id, value, onChange, button, children, buttonClass }) => {
  return (
    <Listbox
      name={name}
      id={id}
      value={value}
      onChange={onChange}
      as="div"
      style={{
        position: 'relative',
      }}
    >
      {({ open }) => (
        <>
          <Listbox.Button
            className={`select ${buttonClass}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '18px',
            }}
          >
            {button}
            <ExpandMoreIcon
              fontSize="small"
              style={{ transform: open ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.3s ease-in-out' }}
            />
          </Listbox.Button>
          <Listbox.Options
            open={true}
            style={{
              maxHeight: '240px',
              overflowY: 'auto',
              backgroundColor: '#FFF',
              position: 'absolute',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
              width: '100%',
              zIndex: 10,
            }}
          >
            {children}
          </Listbox.Options>
        </>
      )}
    </Listbox>
  );
};

Select.Option = ({ value, children }) => {
  return (
    <Listbox.Option value={value}>
      {({ active, selected }) => (
        <div className="select-options">
          <div
            style={{
              padding: '12px 16px',
              backgroundColor: `${selected ? '#FECB04' : ''}`,
            }}
          >
            {children}
          </div>
        </div>
      )}
    </Listbox.Option>
  );
};

export default Select;
